import PL_utils from '../patterns/pl-utils.js';

export default() => {
    if(PL_utils.isMobile() && document.querySelector('input')) {
        document.querySelectorAll('input:not([type="checkbox"]), input:not([type="radio"])').forEach((input) => {
            input.addEventListener('blur', () => {
                document.getElementById('sticky-isi').removeAttribute('hidden');
            });
            input.addEventListener('focus', () => {
                document.getElementById('sticky-isi').setAttribute('hidden', 'true');
            });
        })
    }
}